import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

export const Spacer = ({spacer_size}) => {
    return <Box height={spacer_size} />
}

Spacer.propTypes = {
    spacer_size: PropTypes.string
}

export default Spacer
